<template>
  <v-container>
    <v-app-bar
      app
      flat
      color="primary"
      style="z-index: 1999"
      dark
      class="pa-0 ma-0 subtitle-2"
    >
      <!-- SHOW GO BACK BUTTON CONFIRM DIALOG -->
      <dialog-show-go-back
        :active="showGoBack"
        @clickYes="$router.push('/')"
        @clickNo="showGoBack = false"
      ></dialog-show-go-back>

      <v-spacer></v-spacer>

      <!-- Naslovna vrstica-->
      <v-toolbar-title
        class="mr-12"
        v-if="
          uploadedFiles.length == 0 &&
          $store.state.storeClient.client.modules.modulePhotoOrder
            .enableSimpleUpload &&
          $store.state.storeClient.client.modules.modulePhotoOrder
            .enableSimpleUpload &&
          uploadedFiles.length == 0
        "
      >
        {{ $t("userNewOrderBasicMainMenuTitle") }}
      </v-toolbar-title>
      <v-toolbar-title v-else class="mr-12">
        <span
          v-show="maxLimitPct > 85"
          class="hover-item"
          @click="showFullPackageWarning"
        >
          <v-icon v-if="maxLimitPct > 100" color="error" class="mr-1"
            >mdi-alert</v-icon
          >
          <v-icon v-else color="warning" class="mr-1">mdi-alert</v-icon>
        </span>
        <span
          >{{
            formatBytesMethod(
              $store.state.storeModPhotoOrderUploadService.filesMBLimit
            )
          }}
          / {{ maxLimitMB }} ({{ maxLimitPct }}%)</span
        >
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <!-- HIDDEN FILE INPUT -->
          <v-flex xs12 class="mx-1 mb-1 pa-0" v-show="false">
            <v-card
              outlined
              class="py-0 ma-0"
              style="background-color: #fcfcfc"
            >
              <v-card-text class="pb-0 mb-0" style="height: 100px">
                <v-form
                  enctype="multipart/form-data"
                  ref="formUploader"
                  novalidate
                >
                  <v-file-input
                    ref="imageUploader"
                    id="imageUploader"
                    multiple
                    accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                    prepend-icon="mdi-camera"
                    @change="beforeFilesChange"
                    @click="$event.target.value = ''"
                    :clearable="false"
                    v-model="files"
                    outlined
                    class="mt-1"
                    :label="$t('userNewOrderSelectPhotosCardTitle')"
                  >
                    <!-- prikažemo samo en chip in sicer koliko datotek imamo izbranih -->
                    <template v-slot:selection="{ index }">
                      <v-chip
                        v-show="index == 0"
                        label
                        medium
                        color="primary"
                        class="ma-3 mr-0"
                        >{{ uploadedFiles.length }}</v-chip
                      >
                      <v-btn
                        medium
                        v-show="index == 0"
                        class="ml-3"
                        color="primary"
                        outlined
                      >
                        <v-icon medium class="mr-2">mdi-image-plus</v-icon>
                        {{ $t("userNewOrderBtnAddMoreTitle") }}
                      </v-btn>
                    </template>
                  </v-file-input>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex
            xs12
            class="mx-1 mb-1 pa-0"
            v-show="
              loading ||
              (showUpload &&
                $store.state.storeModPhotoOrderUploadService.uploadProgress
                  .progress < 100)
            "
          >
            <v-progress-linear
              class="ma-0"
              color="primary"
              height="10"
              indeterminate
            ></v-progress-linear>
          </v-flex>

          <v-snackbar
            style="z-index: 3000"
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >

          <!-- LOAD TYPE FIRST MENU SELECTION -->
          <v-flex
            xs12
            class="ma-4 my-3 pa-0"
            v-show="uploadedFiles.length == 0"
          >
            <!-- Nastavitve pošiljanja -->
            <v-alert
              dense
              class="mb-2"
              icon="mdi-information-outline"
              outlined
              dismissible
              text
              type="info"
              >{{ $t("userNewOrderBasicSettingsHelp1Title") }}</v-alert
            >

            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-text class="pt-6 pb-4">
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  <div class="d-flex flex-wrap justify-center pa-0 ma-0">
                    <v-select
                      style="max-width: 130px; min-width: 130px; height: 50px"
                      class="pa-0 ma-0 py-1 mx-1"
                      item-text="name"
                      item-value="name"
                      :items="$store.state.storeImageSize.imageSize"
                      v-model="newOrder.selectedFormat"
                      @change="getSelectedFormatFile"
                      :label="$t('userNewOrderImageSizeHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      v-model="newOrder.selectedCopies"
                      :items="copiesSelectOptions"
                      style="max-width: 80px; min-width: 80px; height: 50px"
                      :label="$t('userNewOrderPcsHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      v-model="newOrder.selectedFitIn"
                      :items="fitInSelectOptions"
                      style="max-width: 110px; min-width: 110px; height: 50px"
                      :label="$t('userNewOrderFillInHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      style="max-width: 140px; min-width: 140px; height: 50px"
                      item-text="paperType"
                      item-value="paperType"
                      :label="paperTypePriceInfo"
                      outlined
                      :items="activePaperTypes"
                      v-model="newOrder.selectedPaperType"
                      @change="selectPaperType1"
                      dense
                    ></v-select>
                  </div>
                  <div class="d-flex flex-wrap justify-center pa-0 ma-0 mt-1">
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedPrintDate"
                      :label="$t('userNewOrderImageDateShortTitle')"
                      v-if="$store.state.storeClient.client.modules.modulePhotoOrder.enableDate"
                    ></v-checkbox>
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedWhiteBorder"
                      :label="$t('userNewOrderImageBorderShortTitle')"
                    ></v-checkbox>
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedAutoCorrection"
                      :label="$t('userNewOrderAutoCorrectionTitle')"
                    ></v-checkbox>
                  </div>
                </div>
                <v-spacer></v-spacer>
              </v-card-text>
              <v-card-actions
                style="
                 background-color: whitesmoke; border-top: 1px solid lightgray;
                "
              >
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center pa-0 ma-0">
                  <v-card
                    v-if="
                      $store.state.storeClient.client.modules.modulePhotoOrder
                        .enableAdvancedUpload
                    "
                    class="
                      d-flex
                      flex-wrap
                      justify-center
                      ma-2
                      outlined
                      text-center
                      elevation-0
                      white--text
                      hover-item
                    "
                    style="
                      min-width: 250px;
                      max-width: 450px;
                      border: 1px solid lightgray;
                    "
                    color="primary"
                    @click="
                      simpleUpload = false;
                      trigger();
                    "
                  >
                    <v-card-title
                      ><v-icon medium color="white" class="mr-2"
                        >mdi-file-edit-outline</v-icon
                      >{{
                        $t("userNewOrderBasicAdvancedUploadTitle")
                      }}</v-card-title
                    >
                    <v-card-text class="white--text"
                      ><div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-check</v-icon
                        >{{ $t("userNewOrderBasicAdvancedUploadDetail0Title") }}
                      </div>
                      <div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-check</v-icon
                        >{{ $t("userNewOrderBasicAdvancedUploadDetail1Title") }}
                      </div>
                      <div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-check</v-icon
                        >{{ $t("userNewOrderBasicAdvancedUploadDetail2Title") }}
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="
                      $store.state.storeClient.client.modules.modulePhotoOrder
                        .enableSimpleUpload
                    "
                    class="
                      d-flex
                      flex-wrap
                      justify-center
                      ma-2
                      outlined
                      text-center
                      elevation-0
                      white--text
                      hover-item
                    "
                    style="
                      min-width: 250px;
                      max-width: 450px;
                      border: 1px solid lightgray;
                    "
                    color="primary"
                    @click="
                      simpleUpload = true;
                      trigger();
                    "
                  >
                    <v-card-title
                      ><v-icon medium color="white" class="mr-2"
                        >mdi-run-fast</v-icon
                      >{{
                        $t("userNewOrderBasicSimpleUploadTitle")
                      }}</v-card-title
                    >
                    <v-card-text class="white--text"
                      ><div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-check</v-icon
                        >{{ $t("userNewOrderBasicSimpleUploadDetail1Title") }}
                      </div>
                      <div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-close</v-icon
                        >{{ $t("userNewOrderBasicSimpleUploadDetail3Title") }}
                      </div>
                      <div class="ma-0 pa-0">
                        <v-icon small color="white" class="mr-2"
                          >mdi-close</v-icon
                        >{{ $t("userNewOrderBasicSimpleUploadDetail2Title") }}
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <v-spacer></v-spacer>
              </v-card-actions>

              <v-card-actions
                style="
                 background-color: whitesmoke; border-top: 1px solid lightgray;
                "
              >
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center pa-0 ma-0">
                  <v-card
                    class="
                      d-flex
                      flex-wrap
                      justify-center
                      ma-2
                      outlined
                      text-center
                      elevation-0
                      hover-item
                    "
                    style="border: 1px solid lightgray"
                    @click="showSettingsHelp = true"
                  >
                    <v-card-text
                      ><div class="ma-0 pa-0">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-help</v-icon
                        >
                        {{ $t("userNewOrderBasicSettingsHelpTitle") }}
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    class="
                      d-flex
                      flex-wrap
                      justify-center
                      ma-2
                      outlined
                      text-center
                      elevation-0
                      hover-item
                    "
                    style="border: 1px solid lightgray"
                    @click="showWarning = true"
                  >
                    <v-card-text
                      ><div class="ma-0 pa-0">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-help</v-icon
                        >
                        {{ $t("userNewOrderBasicOldWarningTitle") }}
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <!-- ADVANCED IMAGE THUMBNAILS MAIN CONTENT -->
          <v-flex
            xs12
            class="mx-1 mb-1 pa-0"
            v-if="uploadedFiles.length > 0 && !simpleUpload"
          >
            <v-card flat class="py-0 ma-0" style="background-color: #fcfcfc">
              <v-card-text class="pa-0 ma-0">
                <v-container fluid style="background-color: #e8e8e8">
                  <v-layout row>
                    <v-flex
                      v-for="(item, index) in uploadedFiles"
                      :key="index"
                      xs12
                      md6
                      xl4
                    >
                      <v-card outlined class="mb-1 mr-1">
                        <v-card-title
                          class="
                            ma-0
                            pa-0
                            d-flex
                            primary
                            white--text
                            subtitle-2
                          "
                        >
                          <div class="pa-1 px-2 d-inline-block">
                            {{ item.num + 1 }}. {{ truncateFilename(item.name) }}
                          </div>
                        </v-card-title>
                        <v-card-subtitle
                          class="d-flex ma-0 pa-1"
                          style="border-bottom: 1px solid lightgray"
                        >
                          <v-spacer v-if="$store.state.storeClient.client.modules.modulePhotoOrder.enableCrop"></v-spacer>
                          <div
                            class="hover-item px-2 py-1"
                            @click="showSingleImage(item)"
                            v-if="$store.state.storeClient.client.modules.modulePhotoOrder.enableCrop"
                          >
                            <v-icon
                              v-show="
                                !item.cropped && item.selectedFitIn == 'FILL-IN'
                              "
                              class="mr-1"
                              small
                              color="error"
                              >mdi-alert</v-icon
                            >
                            <v-icon small color="primary">mdi-crop</v-icon>
                            {{ $t("lmBtnCrop") }}
                          </div>
                          <v-spacer></v-spacer>
                          <div
                            class="hover-item px-2 py-1"
                            @click="
                              dialogImagePreview = true;
                              itemIndex = index;
                            "
                          >
                            <v-icon small color="primary">mdi-eye</v-icon>
                            {{ $t("lmBtnPreview") }}
                          </div>
                          <v-spacer></v-spacer>
                          <div
                            class="hover-item px-2 py-1"
                            @click="removeImage(item.id, item.num)"
                          >
                            <v-icon small color="primary">mdi-trash-can</v-icon>
                            {{ $t("lmBtnRemove") }}
                          </div>
                          <!--<v-spacer></v-spacer>
                          <div class="hover-item px-2 py-1">
                            <v-icon small color="primary">mdi-pencil</v-icon>
                            {{ $t("lmBtnDesign") }}
                          </div>-->
                          <v-spacer></v-spacer>
                        </v-card-subtitle>
                        <v-card-text
                          class="d-flex ma-0 pa-2"
                          style="
                            background-color: #e0e0e0;
                            border-bottom: 2px solid lightgray;
                          "
                        >
                          <div class="ma-0 pa-0">
                            <v-img
                              v-if="item.err"
                              width="150"
                              height="150"
                              :src="redCross"
                              class="ma-1"
                              style="border: 1px solid gray"
                            >
                            </v-img>
                            <v-img
                              v-else
                              class="ma-1 hover-item"
                              contain
                              width="150"
                              height="150"
                              :src="item.srcThumb"
                              @click="
                                dialogImagePreview = true;
                                itemIndex = index;
                              "
                            >
                            </v-img>
                          </div>
                          <div
                            class="ma-0 pa-0 pa-2 pb-1 subtitle-2 text-no-wrap"
                          >
                            <div
                              class="ma-0 pa-0 mb-2"
                              v-if="item.qualityPct < 2"
                            >
                              <span
                                class="pa-1"
                                style="background-color: black; color: white"
                                v-if="item.qualityPct < 1"
                              >
                                {{ $t("vueCropperVeryLowQuality") }}
                              </span>
                              <span
                                class="pa-1"
                                style="background-color: red; color: white"
                                v-else-if="item.qualityPct < 2"
                              >
                                {{ $t("vueCropperLowQuality") }}
                              </span>
                            </div>
                            <div class="ma-0 pa-0 pb-2 hover-item d-flex">
                              <div
                                @click="
                                  dialogSelectFormatActive = true;
                                  itemIndex = index;
                                "
                              >
                                <span class="subtitle-2">
                                  <span
                                    class="mr-1 pa-1"
                                    style="background-color: white"
                                    ><v-icon left small class="ma-0 pa-0"
                                      >mdi-menu-down-outline</v-icon
                                    >{{ item.selectedFormat }}</span
                                  >
                                </span>
                              </div>
                              <div
                                @click="
                                  dialogSelectCopiesActive = true;
                                  itemIndex = index;
                                "
                              >
                                <span class="subtitle-2">
                                  <span
                                    class="pa-1 mr-1"
                                    style="background-color: white"
                                    ><v-icon left small class="ma-0 pa-0"
                                      >mdi-menu-down-outline</v-icon
                                    >{{ item.selectedCopies }}
                                    {{ $t("lmPcs") }}</span
                                  >
                                </span>
                              </div>
                            </div>
                            <div class="ma-0 pa-0 pb-1 d-flex">
                              <div
                                class="hover-item"
                                @click="prepareSelectPapers(item, index)"
                              >
                                <span class="subtitle-2">
                                  <span
                                    class="pa-1 mr-1"
                                    style="background-color: white"
                                    ><v-icon left small class="ma-0 pa-0"
                                      >mdi-menu-down-outline</v-icon
                                    >{{ item.selectedPaperType }}</span
                                  >
                                </span>
                              </div>
                              <div
                                class="hover-item"
                                @click="simplePreFitInImage(item)"
                              >
                                <span
                                  v-if="item.selectedFitIn == 'FIT-IN'"
                                  class="subtitle-2"
                                >
                                  <span
                                    class="pa-1 mr-1"
                                    style="background-color: white"
                                    ><v-icon left small class="ma-0 pa-0"
                                      >mdi-menu-down-outline</v-icon
                                    >FIT-IN</span
                                  >
                                </span>
                                <span v-else class="subtitle-2">
                                  <span
                                    class="pa-1 mr-1"
                                    style="background-color: white"
                                    ><v-icon left small class="ma-0 pa-0"
                                      >mdi-menu-down-outline</v-icon
                                    >FILL-IN</span
                                  >
                                </span>
                              </div>
                            </div>
                            <div
                              v-if="item.selectedWhiteBorder"
                              class="ma-0 pa-0 pb-1 mt-1 hover-item"
                              @click="
                                item.selectedWhiteBorder =
                                  !item.selectedWhiteBorder
                              "
                            >
                              <v-icon small color="green" class="mr-1"
                                >mdi-check</v-icon
                              >{{ $t("userNewOrderImageBorderTitle") }}
                            </div>
                            <div
                              v-else
                              class="ma-0 pa-0 pb-1 mt-1 hover-item"
                              @click="
                                item.selectedWhiteBorder =
                                  !item.selectedWhiteBorder
                              "
                            >
                              <v-icon small color="red" class="mr-1"
                                >mdi-close</v-icon
                              >{{ $t("userNewOrderImageBorderTitle") }}
                            </div>
                            <div v-if="$store.state.storeClient.client.modules.modulePhotoOrder.enableDate">
                              <div
                                v-if="item.selectedPrintDate"
                                class="ma-0 pa-0"                                                           
                              >
                                <span class="ma-0 pa-1 white--text warning">{{ $t("userNewOrderBasicDateOK") }}</span>
                              </div>
                              <div
                                v-if="item.selectedPrintDate"
                                class="ma-1 pa-1 hover-item"
                                @click="
                                  item.cropped
                                    ? prepareTogglePrintDate(item, index)
                                    : simpleTogglePrintDate(item, index)
                                "
                              >
                                {{ formattedLastModified(item.lastModified) }} <span class="ma-1 pa-1" style="box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5)">{{ $t("lmBtnRemove") }}</span>
                              </div>
                              <div
                                v-else
                                class="ma-0 pa-0 pb-1 hover-item"
                                @click="
                                  item.cropped
                                    ? prepareTogglePrintDate(item, index)
                                    : simpleTogglePrintDate(item, index)
                                "
                              >
                                <v-icon small color="red" class="mr-1"
                                  >mdi-close</v-icon
                                >{{ $t("userNewOrderImageDateTitle") }}
                              </div>
                            </div>
                              <div
                              v-if="item.selectedAutoCorrection"
                              class="ma-0 pa-0 pb-1 hover-item"
                              @click="
                                item.selectedAutoCorrection =
                                  !item.selectedAutoCorrection
                              "
                            >
                              <v-icon small color="green" class="mr-1"
                                >mdi-check</v-icon
                              >{{ $t("userNewOrderAutoCorrectionTitle") }}
                            </div>
                            <div
                              v-else
                              class="ma-0 pa-0 pb-1 hover-item"
                              @click="
                                item.selectedAutoCorrection =
                                  !item.selectedAutoCorrection
                              "
                            >
                              <v-icon small color="red" class="mr-1"
                                >mdi-close</v-icon
                              >{{ $t("userNewOrderAutoCorrectionTitle") }}
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <!--<v-card-text
                class="pa-0 ma-1 py-6 d-flex flex-row flex-wrap justify-center"
              >
                <div v-for="item in uploadedFiles" :key="item.id">
                  <v-img
                    v-if="item.err"
                    width="150"
                    height="150"
                    :src="redCross"
                    class="ma-1"
                  >
                    <div
                      class="d-flex flex-column justify-space-between"
                      style="height: 100%"
                    >
                      <div
                        class="d-flex flex-row flex-wrap align-center justify-space-between"
                      >
                        <v-btn
                          fab
                          x-small
                          class="ma-1 elevation-0"
                          style="background: rgba(255, 0, 0, 0.4)"
                          @click="removeImage(item.id, item.num)"
                          @click.stop
                        >
                          <v-icon medium color="white">mdi-trash-can</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-img>
                  <v-img
                    v-else
                    class="ma-1 hover-item"
                    width="150"
                    height="150"
                    :src="item.srcThumb"
                    :style="
                      item.cropped
                        ? 'border: 2px solid green;'
                        : 'border: 2px dashed gray;'
                    "
                    @click="showSingleImage(item)"
                  >
                    <div
                      class="d-flex flex-column justify-space-between"
                      style="height: 100%"
                    >
                      <div
                        class="d-flex flex-row flex-wrap align-center justify-space-between"
                      >
                        <v-btn
                          fab
                          x-small
                          class="ma-1 elevation-0"
                          style="background: rgba(255, 0, 0, 0.4)"
                          @click="removeImage(item.id, item.num)"
                          @click.stop
                        >
                          <v-icon medium color="white">mdi-trash-can</v-icon>
                        </v-btn>
                        <div
                          class="pa-1 px-2 mr-1 subtitle-2 white--text"
                          style="
                            background: rgba(0, 0, 0, 0.4);
                            border-radius: 10px;
                          "
                          @click="showSingleImage(item)"
                          @click.stop
                        >
                          <v-icon
                            color="error"
                            x-small
                            v-if="item.qualityPct < 2"
                            >mdi-star</v-icon
                          >
                          <v-icon
                            color="warning"
                            x-small
                            v-else-if="item.qualityPct < 5"
                            >mdi-star</v-icon
                          >
                          <v-icon color="success" x-small v-else
                            >mdi-star</v-icon
                          >
                          {{ item.selectedFormat }} | {{ item.selectedCopies }}
                        </div>
                        <div
                          class="d-flex flex-row align-center justify-end"
                          style="width: 100%"
                        >
                          <div
                            v-if="item.selectedFitIn == 'FIT-IN'"
                            class="subtitle-2 white--text"
                            @click="showSingleImage(item)"
                            @click.stop
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: orange"
                              >FIT</span
                            >
                          </div>
                          <div
                            v-if="item.selectedPrintDate"
                            class="subtitle-2 white--text"
                            @click="showSingleImage(item)"
                            @click.stop
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >D</span
                            >
                          </div>
                          <div
                            v-if="item.selectedWhiteBorder"
                            class="subtitle-2 white--text"
                            @click="showSingleImage(item)"
                            @click.stop
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >BR</span
                            >
                          </div>
                          <div
                            v-if="item.selectedAutoCorrection"
                            class="subtitle-2 white--text"
                            @click="showSingleImage(item)"
                            @click.stop
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >AC</span
                            >
                          </div>
                          <div
                            style="
                              background: rgba(0, 0, 0, 0.4);
                              border-radius: 5px;
                            "
                            class="mr-1"
                          >
                            <v-icon
                              small
                              class="mx-1"
                              color="white"
                              @click="showSingleImage(item)"
                              @click.stop
                              >mdi-square-edit-outline</v-icon
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="d-flex flex-row align-center justify-space-between"
                      >
                        <v-btn
                          fab
                          x-small
                          class="ma-1 ml-1 elevation-0"
                          style="background: rgba(0, 0, 0, 0.4)"
                          v-if="item.selectedCopies > 1"
                          @click="
                            item.selectedCopies > 1
                              ? item.selectedCopies--
                              : item.selectedCopies;
                            thisOrderTotalImages--;
                          "
                          @click.stop
                        >
                          <v-icon medium color="white">mdi-minus</v-icon>
                        </v-btn>
                        <v-spacer v-if="item.selectedCopies <= 1"></v-spacer>
                        <v-btn
                          fab
                          x-small
                          class="ma-1 mr-1 elevation-0"
                          style="background: rgba(0, 0, 0, 0.4)"
                          @click="
                            item.selectedCopies++;
                            thisOrderTotalImages++;
                          "
                          @click.stop
                        >
                          <v-icon medium color="white">mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </v-img>
                </div>
              </v-card-text>-->
            </v-card>
          </v-flex>

          <!-- SIMPLE IMAGE THUMBNAILS MAIN CONTENT -->
          <v-flex
            xs12
            class="mx-1 mb-1 pa-0"
            v-if="uploadedFiles.length > 0 && simpleUpload"
          >
            <v-card
              outlined
              class="py-0 ma-0"
              style="background-color: #fcfcfc"
            >
              <v-card-text class="pa-0 ma-0">
                <v-container fluid>
                  <v-layout row>
                    <v-flex
                      v-for="item in uploadedFiles"
                      :key="item.id"
                      xs12
                      md6
                      xl4
                    >
                      <div
                        class="pa-2"
                        style="border-bottom: 1px solid lightgray"
                      >
                        <div class="ma-0 pa-0">
                          <v-btn
                            fab
                            x-small
                            class="ma-1 mb-0 elevation-0"
                            style="background: rgba(255, 0, 0, 0.4)"
                            @click="removeImage(item.id, item.num)"
                          >
                            <v-icon medium color="white">mdi-trash-can</v-icon>
                          </v-btn>
                          {{ item.num + 1 }}. {{ truncateFilename(item.name) }}
                        </div>
                        <div class="ma-0 pa-0 ml-11 subtitle-2">
                          <span class="mr-1"
                            >{{ item.selectedFormat }} |
                            {{ item.selectedCopies }} {{ $t("lmPcs") }}</span
                          >
                          <span
                            v-if="item.selectedFitIn == 'FIT-IN'"
                            class="subtitle-2 white--text"
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: orange"
                              >FIT-IN</span
                            >
                          </span>
                          <span v-else class="subtitle-2 white--text">
                            <span
                              class="px-1 mr-1"
                              style="background-color: orange"
                              >FILL-IN</span
                            >
                          </span>
                          <span
                            v-if="item.selectedPrintDate"
                            class="subtitle-2 white--text"
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >D</span
                            >
                          </span>
                          <span
                            v-if="item.selectedWhiteBorder"
                            class="subtitle-2 white--text"
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >BR</span
                            >
                          </span>
                          <span
                            v-if="item.selectedAutoCorrection"
                            class="subtitle-2 white--text"
                          >
                            <span
                              class="px-1 mr-1"
                              style="background-color: green"
                              >AC</span
                            >
                          </span>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- DIALOG IMAGE PREVIEW -->
          <dialog-image-preview
            v-model="dialogImagePreview"
            :imagePreviewTemplate="
              uploadedFiles[itemIndex] != undefined
                ? uploadedFiles[itemIndex].src
                : ''
            "
          ></dialog-image-preview>

          <!-- SHOW DATE TOGGLE DIALOG -->
          <dialog-basic-yes-no
            :active="dialogTogglePrintDate"
            @clickYes="
              simpleTogglePrintDate(currentImagePreview, itemIndex);
              dialogTogglePrintDate = false;
            "
            @clickNo="dialogTogglePrintDate = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgQuestion')"
            >{{ $t("userNewOrderBasicSelectDateInfo") }}</dialog-basic-yes-no
          >

          <!-- SHOW GO UPLOAD DIALOG -->
          <v-dialog
            v-model="showGoUpload"
            persistenthow
            transition="dialog-bottom-transition"
            style="z-index: 2000"
            max-width="400"
          >
            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-comment-question-outline</v-icon
                >
                {{ $t("msgConfirm") }}
              </v-card-title>
              <v-card-text
                v-show="dialogIsAnyPrintDate"
                class="mb-3 px-2 py-1 warning white--text"
              >
                {{ $t("userNewOrderBasicDateWarning") }}
              </v-card-text> 
              <v-card-text
                v-show="thisOrderNotCroppedImages > 0 && !simpleUpload && $store.state.storeClient.client.modules.modulePhotoOrder.enableCrop"
                class="pt-6 pb-0"
              >
                {{ thisOrderNotCroppedImages }}
                {{ $t("userNewOrderBasicNotCroppedImages") }}
              </v-card-text>
              <v-card-text class="pt-6 pb-6">
                {{ $t("userNewOrderBasicGoUpload") }}
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  class="mx-0"
                  @click="showGoUpload = false"
                  >{{ $t("lmBtnNo") }}</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  v-if="showButton"
                  color="primary"
                  text
                  class="mx-0"
                  @click="getOrderSummary"
                  >{{ $t("lmBtnYes") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- DIALOG SELECT FORMAT ITEM -->
          <dialog-select-item
            :active="dialogSelectFormatActive"
            @clickYes="dialogSelectFormatActive = false"
            icon="mdi-hand-pointing-right"
            iType="item.name"
            :title="$t('lmBtnSelect')"
            :cropped="
              uploadedFiles[itemIndex] != undefined
                ? uploadedFiles[itemIndex].cropped
                : false
            "
            :initItems="$store.state.storeImageSize.imageSize"
            :initItem="
              uploadedFiles[itemIndex] != undefined
                ? uploadedFiles[itemIndex].selectedFormat
                : ''
            "
            @selectedItem="simpleFormatSelected($event)"
          ></dialog-select-item>

          <!-- DIALOG SELECT COPIES ITEM -->
          <dialog-select-item
            :active="dialogSelectCopiesActive"
            @clickYes="dialogSelectCopiesActive = false"
            icon="mdi-hand-pointing-right"
            iType="item"
            :title="$t('lmBtnSelect')"
            :initItems="copiesSelectOptions"
            :initItem="
              uploadedFiles[itemIndex] != undefined
                ? uploadedFiles[itemIndex].selectedCopies
                : ''
            "
            @selectedItem="simpleCopiesSelected($event)"
          ></dialog-select-item>

          <!-- DIALOG SELECT PAPER TYPE ITEM -->
          <dialog-select-item
            :active="dialogSelectPaperActive"
            @clickYes="dialogSelectPaperActive = false"
            icon="mdi-hand-pointing-right"
            iType="item"
            :title="$t('lmBtnSelect')"
            :initItems="currentPaperType"
            :initItem="
              uploadedFiles[itemIndex] != undefined
                ? uploadedFiles[itemIndex].selectedPaperType
                : ''
            "
            @selectedItem="simplePaperSelected($event)"
          ></dialog-select-item>

          <!-- SETTINGS HELP DIALOG -->
          <v-dialog
            v-model="showSettingsHelp"
            persistent
            max-width="1200"
            transition="dialog-bottom-transition"
            scrollable
            style="z-index: 2000"
          >
            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-help</v-icon
                >
                {{ $t("msgHelpTitle") }}
              </v-card-title>
              <v-card-text class="pa-0">
                <div class="subtitle-2 pa-4 pb-2">
                  {{ $t("userNewOrderBasicSettingsHelpFillInTitle") }}
                </div>
                <div class="px-4">
                  {{ $t("userNewOrderBasicSettingsHelpFillIn") }}
                </div>
                <v-img contain max-height="450" :src="fillfitImage"></v-img>
                <div class="subtitle-2 pt-0 pb-2">
                  {{ $t("userNewOrderImageDateShortTitle") }}
                </div>
                <div class="px-4">
                  {{ $t("userNewOrderBasicSettingsHelpDate") }}
                </div>
                <v-img contain max-height="250" :src="dateImage"></v-img>
                <div class="subtitle-2 pt-0 pb-2">
                  {{ $t("userNewOrderImageBorderShortTitle") }}
                </div>
                <div class="px-4">
                  {{ $t("userNewOrderBasicSettingsHelpBR") }}
                </div>
                <v-img contain max-height="250" :src="brImage"></v-img>
                <div class="subtitle-2 pt-0 pb-2">
                  {{ $t("userNewOrderAutoCorrectionTitle") }}
                </div>
                <div class="px-4 pb-4">
                  {{ $t("userNewOrderBasicSettingsHelpAC") }}
                </div>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  class="mx-0"
                  @click="showSettingsHelp = false"
                  >{{ $t("lmBtnClose") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- WARNING DIALOG -->
          <v-dialog
            v-model="showWarning"
            persistent
            scrollable
            max-width="500"
            transition="dialog-bottom-transition"
            style="z-index: 2000"
          >
            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-help</v-icon
                >
                {{ $t("msgHelpTitle") }}
              </v-card-title>
              <v-card-text class="pt-6 pb-6">
                <div>{{ $t("userNewOrderBasicOldWarning") }}</div>
                <div class="mt-4">{{ $t("userNewOrderBasicOldWarning2") }}</div>
                <div class="mt-4">{{ $t("userNewOrderBasicOldWarning3") }}</div>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  class="mx-0"
                  @click="showWarning = false"
                  >{{ $t("lmBtnClose") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- IMAGE LOADING DIALOG -->
          <v-dialog
            v-model="loading"
            persistent
            max-width="320"
            transition="dialog-bottom-transition"
            style="z-index: 2000"
          >
            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-3"
                  medium
                  >mdi-timer-sand</v-icon
                >
                {{ $t("lmPleaseWait") }}
              </v-card-title>
              <v-card-text class="pt-6 pb-0">
                <p class="overline">
                  {{ $t("userNewOrderPreviewDialogTitle") }}
                </p>
                <p class="title">
                  {{
                    $store.state.storeModPhotoOrderUploadService.readingImages
                  }}
                  /
                  {{
                    $store.state.storeModPhotoOrderUploadService
                      .readingImagesLength
                  }}
                  ({{ getReadingImagesProgress }}%)
                </p>
                <p class="overline">
                  {{ truncateFilename(currentProcessingFile) }}
                </p>
                <p v-if="isConvertingHeic" class="overline warning--text">
                  {{ $t("userNewOrderBasicHeicConversion") }}
                </p>
                <p class="overline">
                  {{
                    formatBytesMethod(
                      $store.state.storeModPhotoOrderUploadService.filesMBSize
                    )
                  }}
                </p>
                <div v-if="showSkipButton" class="mb-2">
                  <v-btn
                    small
                    color="warning"
                    outlined
                    @click="skipCurrentFile"
                  >
                    {{ $t("userNewOrderBasicBtnSkipFile") }}
                  </v-btn>
                </div>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="mx-0" @click="hardRefresh">{{
                  $t("userNewOrderBasicBtnCancelOrder")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- DIALOG VUE CROPPER IMAGE -->
          <dialog-vue-cropper-image
            v-model="showSingleImageSettings"
            :cropperItem="currentImagePreview"
            @croppedImage="cropFinal2($event)"
          ></dialog-vue-cropper-image>

          <!-- ORDER SETTINGS DIALOG -->
          <v-dialog
            v-model="extendBottomBar"
            persistent
            transition="dialog-bottom-transition"
            max-width="600"
            style="z-index: 2000"
          >
            <v-card
              class="text-center"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
              "
            >
              <v-card-title
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: #505050'
                    : 'background-color: white; border-bottom: 1px solid lightgray'
                "
                :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
                class="title font-weight-regular"
              >
                <v-icon
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  class="mr-2"
                  medium
                  >mdi-settings</v-icon
                >
                {{ $t("userNewOrderBasicSettingsTitle") }}
                <v-spacer></v-spacer>
                <v-btn
                  text
                  medium
                  @click="extendBottomBar = false"
                  style="min-width: 0; width: 20px"
                >
                  <v-icon
                    medium
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    >mdi-close-box</v-icon
                  >
                </v-btn>
              </v-card-title>
              <v-card-text class="pt-6 pb-4">
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  <div class="d-flex flex-wrap justify-center pa-0 ma-0">
                    <v-select
                      style="max-width: 130px; min-width: 130px; height: 50px"
                      class="pa-0 ma-0 py-1 mx-1"
                      item-text="name"
                      item-value="name"
                      :items="$store.state.storeImageSize.imageSize"
                      v-model="newOrder.selectedFormat"
                      @change="getSelectedFormatFile"
                      :label="$t('userNewOrderImageSizeHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      v-model="newOrder.selectedCopies"
                      :items="copiesSelectOptions"
                      style="max-width: 80px; min-width: 80px; height: 50px"
                      :label="$t('userNewOrderPcsHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      v-model="newOrder.selectedFitIn"
                      :items="fitInSelectOptions"
                      style="max-width: 110px; min-width: 110px; height: 50px"
                      :label="$t('userNewOrderFillInHint')"
                      dense
                      outlined
                    ></v-select>
                    <v-select
                      class="pa-0 ma-0 py-1 mx-1"
                      style="max-width: 140px; min-width: 140px; height: 50px"
                      item-text="paperType"
                      item-value="paperType"
                      :label="paperTypePriceInfo"
                      outlined
                      :items="activePaperTypes"
                      v-model="newOrder.selectedPaperType"
                      @change="selectPaperType1"
                      dense
                    ></v-select>
                  </div>
                  <div class="d-flex flex-wrap justify-center pa-0 ma-0 mt-1">
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedPrintDate"
                      :label="$t('userNewOrderImageDateShortTitle')"
                      v-if="$store.state.storeClient.client.modules.modulePhotoOrder.enableCrop"
                    ></v-checkbox>
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedWhiteBorder"
                      :label="$t('userNewOrderImageBorderShortTitle')"
                    ></v-checkbox>
                    <v-checkbox
                      style="height: 30px"
                      class="pa-0 ma-0 mx-1"
                      v-model="newOrder.selectedAutoCorrection"
                      :label="$t('userNewOrderAutoCorrectionTitle')"
                    ></v-checkbox>
                  </div>
                </div>
                <v-spacer></v-spacer>
              </v-card-text>
              <v-card-actions
                :class="
                  getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                    : 'background-color: white; border-top: 1px solid lightgray;'
                "
              >
                <v-spacer></v-spacer>
                <v-btn color="primary my-1" text @click="resetOrderSettings">
                  {{ $t("lmBtnReset") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  class="px-3"
                  color="primary my-1"
                  style="elevation-0"
                  @click="
                    extendBottomBar = false;
                    trigger();
                  "
                  ><v-icon small color="white" class="mr-2">mdi-plus</v-icon
                  >{{ $t("userNewOrderBasicBtnAdd") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- ERRO MSG DIALOG -->
          <dialog-basic-msg
            :active="dialogErrorMsg"
            @clickYes="$router.push('/')"
            icon="mdi-alert-octagon"
            :title="$t('msgError')"
            :body="errorMsgStr"
          ></dialog-basic-msg>

          <!-- DIALOG UPLOAD -->
          <dialog-upload
            :active="showUpload"
            @clickNewOrder="setNewOrder"
          ></dialog-upload>
        </v-layout>
      </div>

      <!-- BOTTOM APP BAR -->
      <v-app-bar
        app
        bottom
        style="z-index: 1999; height: 80px; border-top: 1px solid lightgray"
        class="pt-2"
        elevation-0
        text
        dark
        :class="getTheme() === 'dark' ? 'white--text' : 'primary--text'"
        v-if="uploadedFiles.length > 0"
      >
        <v-spacer></v-spacer>
        <v-btn
          dark
          class="elevation-0 mx-1 animated bounce"
          style="animation-delay: 5s"
          @click="extendBottomBar = true"
          v-show="!disableAdd"
        >
          <v-icon color="white" class="mr-2">mdi-plus-box-outline</v-icon>
          {{ $t("userNewOrderBasicBtnAdd") }}</v-btn
        >
        <v-btn
          dark
          class="elevation-0 mx-1 animated bounce"
          style="animation-delay: 6s"
          @click="checkIfAnyPrintDate"
        >
          <v-badge right color="error">
            <template v-slot:badge>{{ thisOrderTotalImages }}</template>
            <v-icon color="white" class="mr-2">mdi-cloud-upload</v-icon>
            <span class="mr-1">{{ $t("userNewOrderBasicBtnUpload") }}</span>
          </v-badge>
        </v-btn>
        <v-spacer></v-spacer>
      </v-app-bar>
    </v-main>
  </v-container>
</template>

<script>
import Vue from "vue";
import {
  G_COPIES_SELECT_OPTIONS,
  G_MODULE_PHOTO_ORDER,
  G_STORAGE_DEFAULT_DIR,
} from "@/constants";
import { v4 as uuidv4 } from "uuid";
import { preparePreview } from "@/mixins/modPhotoOrderUploadService";
import firebase from "firebase/app"; // za servertimestamp
import { storage } from "@/firebase";
import * as JSZip from "jszip";
import { formatBytes, maxMB, makeId } from "@/mixins/utils";
import moment from "moment";
import heic2any from "heic2any";
import DialogUpload from "@/components/DialogUpload";
import DialogShowGoBack from "@/components/DialogShowGoBack";
import DialogSelectItem from "@/components/DialogSelectItem";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DialogImagePreview from "@/components/DialogImagePreview";
import DialogVueCropperImage from "@/components/DialogVueCropperImage";
import DialogBasicMsg from "@/components/DialogBasicMsg";

export default {
  name: "userNewOrderBasic",
  components: {
    DialogUpload,
    DialogShowGoBack,
    DialogSelectItem,
    DialogBasicYesNo,
    DialogImagePreview,
    DialogVueCropperImage,
    DialogBasicMsg,
  },
  data() {
    return {
      currentPaperType: [],
      itemIndex: 0,
      simpleUpload: true,
      redCross: require("@/assets/icon-red-cross.jpg"),
      backImage: require("@/assets/add.png"),
      fillfitImage: require("@/assets/fillfit.jpg"),
      dateImage: require("@/assets/datum.jpg"),
      brImage: require("@/assets/br.jpg"),
      images: [],
      files: [],
      failedFiles: [],
      currentProcessingFile: "",
      showSkipButton: false,
      skipFileTrigger: null,
      isConvertingHeic: false,
      cViewMode: 1,
      errorMsgStr: "", // sporočilo o napaki
      dialogErrorMsg: false, // simple dialog error
      dialogSelectFormatActive: false,
      dialogSelectCopiesActive: false,
      dialogSelectPaperActive: false,
      dialogTogglePrintDate: false,
      dialogIsAnyPrintDate: false,
      dialogImagePreview: false,
      disableAdd: false, // ali onemogočimo gumb za dodajanje
      loading: false, // nalaganje slik v paket
      showSingleImageSettings: false,
      showWarning: false,
      showSettingsHelp: false,
      showUpload: false,
      showGoBack: false,
      showGoUpload: false,
      uploadedFiles: [],
      uploadError: null,
      uploadEmptyFiles: 0,
      extendBottomBar: false,
      copiesSelectOptions: G_COPIES_SELECT_OPTIONS,
      fitInSelectOptions: ["FILL-IN", "FIT-IN"],
      orderErrorCount: 0,
      thisOrderTotalImages: 0,
      thisOrderNotCroppedImages: 0,
      defaultImageSize: {},
      defaultPaperType: {},
      currentImagePreview: { name: "" },
      singleImagePreviewStartCopies: 0,      
      showButton: true, // za reset click.once
      newOrder: {
        selectedFormat: "",
        selectedFormatFile: "",
        selectedPaperType: "",
        selectedPaperTypeFile: "",
        selectedCopies: "1",
        selectedFitIn: "FILL-IN",
        selectedWhiteBorder: false,
        selectedPrintDate: false,
        selectedAutoCorrection: true,
      },
      orderSummary: {
        totalSumImagePrice: 0,
        totalSumLabPrice: 0,
        totalSumQuantityPrice: 0,
        totalSumFullPrice: 0,
        totalImages: 0,
        totalCopies: 0,
        totalSumImageSizes: [],
        deliveryType: "",
        messageForStudio: "",
      },
    };
  },
  computed: {
    maxLimitPct() {
      return Math.round(
        (this.$store.state.storeModPhotoOrderUploadService.filesMBLimit /
          1000000 /
          maxMB()) *
          100
      );
    },
    maxLimitMB() {
      if (maxMB() >= 1000) {
        return " " + maxMB() / 1000 + " GB ";
      } else return " " + maxMB() + " MB ";
    },
    getImageDate() {
      return moment(this.currentImagePreview.lastModified).format(
        this.$store.state.storeClient.client.environmentSettings.dateFormat
      );
    },
    getReadingImagesProgress() {
      let val = Math.trunc(
        (this.$store.state.storeModPhotoOrderUploadService.readingImages /
          this.$store.state.storeModPhotoOrderUploadService
            .readingImagesLength) *
          100
      );
      //console.log(val);
      return isNaN(val) ? 0 : val;
    },
    paperTypePriceInfo() {
      let ptItem = this.$store.state.storePaperType.paperType.find(
        (item) => item.paperType == this.newOrder.selectedPaperType
      );
      try {
        return ptItem.price > 0
          ? this.$t("userNewOrderPaperTypeExtraPay") + ptItem.price + "%"
          : this.$t("userNewOrderPaperTypeNoExtraPay");
      } catch (e) {
        return this.$t("userNewOrderNoPaperTypeForSelectedFormatShort");
      }
    },
    activePaperTypes() {
      let imageItem = this.$store.state.storeImageSize.imageSize.find(
        (item) => item.name == this.newOrder.selectedFormat
      );
      if (
        imageItem.selectedPaperTypes.includes(this.defaultPaperType.paperType)
      ) {
        // direktno spreminjanje spremenljivke, ni priporočljivo, ampak drugače ne znam trenutno rešiti
        // eslint-disable-next-line
        this.newOrder.selectedPaperType = this.defaultPaperType.paperType;
        // eslint-disable-next-line
        this.newOrder.selectedPaperTypeFile =
          this.defaultPaperType.paperTypeFile;
      } else {
        // če ni default papirja pod to velikostjo, potem je izbor prvi vnešen papir
        // ki mu je treba še poiskati njegov File ime
        // eslint-disable-next-line
        this.newOrder.selectedPaperType = imageItem.selectedPaperTypes[0];
        // eslint-disable-next-line
        this.newOrder.selectedPaperTypeFile =
          this.$store.state.storePaperType.paperType.find(
            (x) => x.paperType == this.newOrder.selectedPaperType
          ).paperTypeFile;
      }
      //console.log(this.newOrder);
      return imageItem.selectedPaperTypes;
    },
    activePaperTypes2() {
      if (this.currentImagePreview.name != "") {
        let imageItem = this.$store.state.storeImageSize.imageSize.find(
          (item) => item.name == this.currentImagePreview.selectedFormat
        );

        /*this.currentImagePreview.selectedPaperType = imageItem.selectedPaperTypes.find(
          (item) => item == this.currentImagePreview.selectedFormat
        )
        if (
          imageItem.selectedPaperTypes.includes(this.defaultPaperType.paperType)
        ) {
          // direktno spreminjanje spremenljivke, ni priporočljivo, ampak drugače ne znam trenutno rešiti
          // eslint-disable-next-line
          this.currentImagePreview.selectedPaperType = this.defaultPaperType.paperType;
          // eslint-disable-next-line
          this.currentImagePreview.selectedPaperTypeFile = this.defaultPaperType.paperTypeFile;
        } else {
          // če ni default papirja pod to velikostjo, potem je izbor prvi vnešen papir
          // ki mu je treba še poiskati njegov File ime
          // eslint-disable-next-line
          this.currentImagePreview.selectedPaperType =
            imageItem.selectedPaperTypes[0];
          // eslint-disable-next-line
          this.currentImagePreview.selectedPaperTypeFile = this.$store.state.storePaperType.paperType.find(
            (x) => x.paperType == this.currentImagePreview.selectedPaperType
          ).paperTypeFile;
        }*/
        return imageItem.selectedPaperTypes;
      } else return 0;
    },
    calcMargin() {
      let rHeight = this.$vuetify.breakpoint.height / 2.2;
      let rWidth = rHeight * this.currentImagePreview.aspectRatio;
      if (rWidth >= this.$vuetify.breakpoint.width) {
        return "margin: 0; width: 100%";
      } else {
        if (rWidth < 220) {
          return "margin: 0; width: 220px";
        } else return "margin: 0; width: " + rWidth + "px";
      }
    },
    calcMarginPreview() {
      let rHeight = this.$vuetify.breakpoint.height / 2.2;
      let rWidth = rHeight * this.currentImagePreview.aspectRatioStore;
      if (rWidth >= this.$vuetify.breakpoint.width) {
        return "margin: 0; width: 100%";
      } else {
        if (rWidth < 220) {
          return "margin: 0; width: 220px";
        } else return "margin: 0; width: " + rWidth + "px";
      }
    },
  },
  methods: {
    truncateFilename(filename) {
      if (!filename) return "";
      if (filename.length <= 30) return filename;
      const extIndex = filename.lastIndexOf(".");
      if (extIndex === -1) {
        return filename.substring(0, 27) + "...";
      }
      const ext = filename.substring(extIndex);
      const namePartLength = 30 - 3 - ext.length;
      if (namePartLength < 1) return filename.substring(0, 27) + "...";

      return filename.substring(0, namePartLength) + "..." + ext;
    },
    formattedLastModified(item) {            
      if (item) {
        const timestamp = item;

        // Preverimo, ali je timestamp v milisekundah ali sekundah.
        // Če je manjši od milijarde (npr. 1678886400), ga obravnavamo kot sekunde.
        const isSeconds = timestamp < 10000000000; //10 milijard - razumna meja za milisekunde

        const momentObj = isSeconds ? moment.unix(timestamp) : moment(timestamp); //pretvorba v moment object

        const format = this.$store.state.storeClient.client.environmentSettings.dateFormat || 'DD.MM.YYYY';  // Default format        
        return momentObj.format(format);
      } else {
        return this.$t("msgError");
      }
    },
    prepareSelectPapers(item, index) {
      this.dialogSelectPaperActive = true;
      this.itemIndex = index;

      this.currentPaperType = this.$store.state.storeImageSize.imageSize.filter(
        (x) => {
          return x.name == item.selectedFormat;
        }
      )[0].selectedPaperTypes;
    },
    simpleFormatSelected(item) {
      this.dialogSelectFormatActive = false;

      this.currentImagePreview = this.uploadedFiles[this.itemIndex];

      if (this.currentImagePreview.cropped) this.thisOrderNotCroppedImages++;
      this.currentImagePreview.file.cropped = false;

      let tFormat = this.$store.state.storeImageSize.imageSize.find(
        (x) => x.name == item
      );

      this.currentPaperType = this.$store.state.storeImageSize.imageSize.filter(
        (x) => {
          return x.name == tFormat.nameFile;
        }
      )[0].selectedPaperTypes;

      this.currentImagePreview.file.selectedFormatFile = tFormat.nameFile;
      this.currentImagePreview.file.selectedFormat = tFormat.name;
      this.currentImagePreview.file.selectedCopies =
        this.currentImagePreview.selectedCopies;
      this.currentImagePreview.file.selectedFitIn =
        this.currentImagePreview.selectedFitIn;

      if (
        this.currentPaperType.some(
          (x) => x == this.currentImagePreview.selectedPaperType
        )
      ) {
        this.currentImagePreview.file.selectedPaperType =
          this.currentImagePreview.selectedPaperType;
        this.currentImagePreview.file.selectedPaperTypeFile =
          this.currentImagePreview.selectedPaperTypeFile;
      } else {
        this.currentImagePreview.file.selectedPaperType =
          this.currentPaperType[0];
        this.currentImagePreview.file.selectedPaperTypeFile =
          this.$store.state.storePaperType.paperType.find(
            (x) =>
              x.paperType == this.currentImagePreview.file.selectedPaperType
          ).paperTypeFile;        
        //console.log("CTYPE", this.currentPaperType[0]);
      }

      this.currentImagePreview.file.selectedPrintDate =
        this.currentImagePreview.selectedPrintDate;
      this.currentImagePreview.file.selectedWhiteBorder =
        this.currentImagePreview.selectedWhiteBorder;
      this.currentImagePreview.file.selectedAutoCorrection =
        this.currentImagePreview.selectedAutoCorrection;

      preparePreview([this.currentImagePreview.file], "edit")
        .then((x) => {
          this.uploadedFiles.splice(this.itemIndex, 1, x[0]);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console      
          console.log(err);
        });
    },
    simpleCopiesSelected(item) {
      this.dialogSelectCopiesActive = false;

      this.currentImagePreview = this.uploadedFiles[this.itemIndex];

      this.currentImagePreview.selectedCopies = String(
        this.uploadedFiles[this.itemIndex].selectedCopies
      );
      this.singleImagePreviewStartCopies =
        this.currentImagePreview.selectedCopies;

      this.uploadedFiles[this.itemIndex].selectedCopies = item;

      this.thisOrderTotalImages +=
        this.currentImagePreview.selectedCopies -
        this.singleImagePreviewStartCopies;
    },
    simplePaperSelected(item) {
      this.dialogSelectPaperActive = false;

      this.uploadedFiles[this.itemIndex].selectedPaperType = item;
      this.uploadedFiles[this.itemIndex].selectedPaperTypeFile =
        this.$store.state.storePaperType.paperType.find(
          (x) => x.paperType == item
        ).paperTypeFile;
    },
    hardRefresh() {
      location.reload(true);
    },
    selectPaperType1() {
      this.newOrder.selectedPaperTypeFile =
        this.$store.state.storePaperType.paperType.find(
          (x) => x.paperType == this.newOrder.selectedPaperType
        ).paperTypeFile;
    },
    selectPaperType2() {
      this.currentImagePreview.selectedPaperTypeFile =
        this.$store.state.storePaperType.paperType.find(
          (x) => x.paperType == this.currentImagePreview.selectedPaperType
        ).paperTypeFile;
      //console.log(this.currentImagePreview);
    },
    getSelectedFormatFile() {
      this.newOrder.selectedFormatFile =
        this.$store.state.storeImageSize.imageSize.find(
          (x) => x.name == this.newOrder.selectedFormat
        ).nameFile;
    },
    showFullPackageWarning() {
      this.$store.commit({
        type: "showSnackbar",
        timeout: 6000,
        color: "warning",
        message: this.$t("userNewOrderBasicPackageFull"),
      });
    },
    isMaxLimit(size) {
      if (
        (this.$store.state.storeModPhotoOrderUploadService.filesMBLimit +
          size) /
          1000000 >=
        maxMB()
      ) {
        return true;
      } else return false;
    },
    showSingleImage(item) {
      if (item.cropped) this.thisOrderNotCroppedImages++;

      item.cropped = false;
      item.file.selectedFitIn = item.selectedFitIn;
      item.file.num = item.num;

      preparePreview([item.file], "edit")
        .then((x) => {
          this.uploadedFiles.splice(item.num, 1, x[0]);
          item = x[0];

          this.cViewMode = 1;

          this.currentImagePreview = item;
          //console.log(this.currentImagePreview);

          this.showSingleImageSettings = true;
        })
        /*.catch((err) => {          
          console.log(err);
        });*/
    },
    async setNewCropperImage() {
      if (this.$refs.cropper != undefined) {
        this.$refs.cropper.destroy();
      }
      //console.log(this.currentImagePreview);
      // cropper update z novo sliko

      let that = this;
      setTimeout(function () {
        that.$refs.cropper.replace(that.currentImagePreview.src);
        that.$refs.cropper.setAspectRatio(
          that.currentImagePreview.sWidth / that.currentImagePreview.sHeight
        );
      }, 200);

      // timeout, da potegne zoom, sicer ga ne
      // zoom 3%, ker drugače malo fali velikost zgoraj in spodaj
      setTimeout(function () {
        //that.$refs.cropper.relativeZoom(0.02);
        if (that.currentImagePreview.selectedFitIn != "FILL-IN")
          that.fitInImage();
        //let contData = that.$refs.cropper.getContainerData(); //Get container data
        //console.log(contData);
        //cropper.setCropBoxData({ height: contData.height, width: contData.width  }) //set data
      }, 500);
    },
    cropFinal2(image) {
      this.currentImagePreview.src = image.src;
      this.currentImagePreview.srcThumb = image.srcThumb;

      this.uploadedFiles[this.currentImagePreview.num].src =
        this.currentImagePreview.src;

      setTimeout(() => {
        this.currentImagePreview.cropped = true;
        this.uploadedFiles[this.currentImagePreview.num].cropped = true;
        this.uploadedFiles[this.currentImagePreview.num].selectedFitIn =
          "FILL-IN";
        this.thisOrderNotCroppedImages--;
        this.showSingleImageSettings = false;
      }, 250);
    },
    simplePreFitInImage(item) {
      if (item.selectedFitIn == "FIT-IN") {
        item.file.selectedFitIn = "FILL-IN";
        this.thisOrderNotCroppedImages++;
      } else if (item.selectedFitIn == "FILL-IN") {
        item.file.selectedFitIn = "FIT-IN";
        this.thisOrderNotCroppedImages--;
      }
      item.file.selectedFormatFile = item.selectedFormatFile;
      item.file.selectedFormat = item.selectedFormat;
      item.file.selectedPrintDate = item.selectedPrintDate;
      item.file.selectedCopies = item.selectedCopies;
      item.file.selectedPaperType = item.selectedPaperType;
      item.file.selectedPaperTypeFile = item.selectedPaperTypeFile;
      item.file.selectedWhiteBorder = item.selectedWhiteBorder;
      item.file.selectedAutoCorrection = item.selectedAutoCorrection;
      item.file.num = item.num;
      item.file.cropped = false;

      preparePreview([item.file], "edit")
        .then((x) => {
          this.uploadedFiles.splice(item.num, 1, x[0]);
          item = x[0];
        })
/*        .catch((err) => {          
          console.log(err);
        });*/
    },
    checkIfAnyPrintDate() {      

      if (!this.simpleUpload) {
        for (let i = this.uploadedFiles.length - 1; i >= 0; i--) {
          if (this.uploadedFiles[i].selectedPrintDate) {
            this.dialogIsAnyPrintDate = true;
          }
          if (this.uploadedFiles[i].aspectRatio === undefined) {
            this.uploadedFiles.splice(i, 1); // Odstrani element na indeksu i          
            this.uploadEmptyFiles++; // Če želiš šteti odstranjene elemente
          }
        }

        /*console.log(this.uploadedFiles)
        console.log(this.uploadEmptyFiles)*/

        if (this.uploadedFiles.length > 0) {
          this.showGoUpload = true;
        }
      } else {
        this.showGoUpload = true;
      }
    },
    prepareTogglePrintDate(item, index) {
      this.currentImagePreview = item;
      this.itemIndex = index;
      this.dialogTogglePrintDate = true;      
    },
    simpleTogglePrintDate(item, index) {
      item.file.selectedFormatFile = item.selectedFormatFile;
      item.file.selectedFormat = item.selectedFormat;
      item.file.selectedPrintDate = !item.selectedPrintDate;
      item.file.selectedCopies = item.selectedCopies;
      item.file.selectedFitIn = item.selectedFitIn;
      item.file.selectedPaperType = item.selectedPaperType;
      item.file.selectedPaperTypeFile = item.selectedPaperTypeFile;
      item.file.selectedWhiteBorder = item.selectedWhiteBorder;
      item.file.selectedAutoCorrection = item.selectedAutoCorrection;

      preparePreview([item.file], "edit")
        .then((x) => {
          this.uploadedFiles.splice(index, 1, x[0]);
          item = x[0];
        })
        .catch((err) => {
          // eslint-disable-next-line no-console       
          console.log(err);
        });
    },
    fitInImage() {
      //this.resetImage();
      const cropBoxData = this.$refs.cropper.getCropBoxData();
      let canvasData = this.$refs.cropper.getCanvasData();
      const cropBoxRatio = cropBoxData.width / cropBoxData.height;
      const canvasRatio = canvasData.width / canvasData.height;

      if (this.currentImagePreview.orientation == "landscape") {
        if (cropBoxRatio <= canvasRatio) {
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: cropBoxData.top,
            width: cropBoxData.width,
          });
          canvasData = this.$refs.cropper.getCanvasData();
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: (cropBoxData.height - canvasData.height) / 2,
            width: cropBoxData.width,
          });
        } else {
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: cropBoxData.top,
            height: cropBoxData.height,
          });
          canvasData = this.$refs.cropper.getCanvasData();
          this.$refs.cropper.setCanvasData({
            top: cropBoxData.top,
            left: (cropBoxData.width - canvasData.width) / 2,
            height: cropBoxData.height,
          });
        }
      } else {
        if (cropBoxRatio > canvasRatio) {
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: cropBoxData.top,
            height: cropBoxData.height,
          });
          canvasData = this.$refs.cropper.getCanvasData();
          this.$refs.cropper.setCanvasData({
            top: cropBoxData.top,
            left: (cropBoxData.width - canvasData.width) / 2,
            height: cropBoxData.height,
          });
        } else {
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: cropBoxData.top,
            width: cropBoxData.width,
          });
          canvasData = this.$refs.cropper.getCanvasData();
          this.$refs.cropper.setCanvasData({
            left: cropBoxData.left,
            top: (cropBoxData.height - canvasData.height) / 2,
            width: cropBoxData.width,
          });
        }
      }
    },

    resetOrderSettings() {
      this.newOrder.selectedFormat = this.defaultImageSize.name;
      this.newOrder.selectedPaperType = this.defaultPaperType.paperType;
      this.newOrder.selectedFormatFile = this.defaultImageSize.nameFile;
      this.newOrder.selectedPaperTypeFile = this.defaultPaperType.paperTypeFile;

      this.newOrder.selectedCopies = "1";
      this.newOrder.selectedFitIn = "FILL-IN";
      this.newOrder.selectedWhiteBorder = false;
      this.newOrder.selectedPrintDate = false;
      this.newOrder.selectedAutoCorrection = true;
    },
    formatBytesMethod(val) {
      return formatBytes(val);
    },
    trigger() {
      document.getElementById("imageUploader").click();
    },
    removeImage(id, num) {
      const index = this.uploadedFiles.findIndex((item) => item.id == id);
      this.thisOrderTotalImages -= this.uploadedFiles[index].selectedCopies;
      if (!this.uploadedFiles[index].cropped) this.thisOrderNotCroppedImages--;

      this.$store.dispatch("filesMBLimit", -this.uploadedFiles[index].size);
      this.uploadedFiles.splice(index, 1);

      if (!this.isMaxLimit(0)) this.disableAdd = false; // omogočimo dodajanje, če je manj kot 100%

      // zaporedna številka se mora zmanjšati pri vseh naslednjih slikah
      for (let i = num; i <= this.uploadedFiles.length - 1; i++) {
        this.uploadedFiles[i].num -= 1;
      }
    },
    setNewOrder() {
      this.showButton = true;
      this.showUpload = false;
      this.disableAdd = false;
      this.$store.dispatch("filesMBLimit", 0);
      this.initNewOrder();
    },
    initNewOrder() {
      this.defaultImageSize = this.$store.state.storeImageSize.imageSize.find(
        (x) => {
          // filter default image size from storeImageSize
          return x.default;
        }
      );
      this.newOrder.selectedFormat = this.defaultImageSize.name;
      this.newOrder.selectedFormatFile = this.defaultImageSize.nameFile;

      this.defaultPaperType = this.$store.state.storePaperType.paperType.find(
        (x) => {
          return x.default;
        }
      );
      this.newOrder.selectedPaperType = this.defaultPaperType.paperType;
      this.newOrder.selectedPaperTypeFile = this.defaultPaperType.paperTypeFile;

      this.newOrder.selectedCopies = "1";
      this.newOrder.selectedFitIn = "FILL-IN";
      this.newOrder.selectedWhiteBorder = false;
      this.newOrder.selectedPrintDate = false;
      this.newOrder.selectedAutoCorrection = true;

      this.uploadedFiles = [];
      this.uploadError = null;
      this.uploadEmptyFiles = 0;

      this.thisOrderTotalImages = 0;
      this.thisOrderNotCroppedImages = 0;

      this.$store.state.storeModPhotoOrderUploadService.generatingZipProgress =
        {};
      this.$store.state.storeModPhotoOrderUploadService.uploadProgress = {};
    },
    getOrderSummary() {
      this.showButton = false;
      this.orderErrorCount = 0;

      Array.from(this.uploadedFiles).forEach((file) => {
        if (file.selectedPaperType.length == 0) this.orderErrorCount += 1;
      });

      if (this.orderErrorCount > 0) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message:
            this.$t("userNewOrderNoPaperTypeForSelectedFormat") +
            " " +
            this.$t("userNewOrderNumOfErrors") +
            " " +
            this.orderErrorCount,
        });
      } else {
        this.orderSummary.totalSumImagePrice = 0;
        this.orderSummary.totalImages = this.uploadedFiles.length;
        this.orderSummary.totalCopies = 0;
        this.orderSummary.totalSumLabPrice = 0;
        this.orderSummary.totalSumQuantityPrice = 1;
        this.orderSummary.totalSumFullPrice = 0;
        this.orderSummary.deliveryType = "";
        this.orderSummary.messageForStudio = "";
        this.orderSummary.totalSumImageSizes =
          this.$store.state.storeImageSize.imageSize;

        // nastavimo kopije vsake velikosti na 0 in dodamo totalSumPaperTypes seznam
        Array.from(this.orderSummary.totalSumImageSizes).forEach((x) => {
          // pripravimo array za računanje koliko slik za različne tipe papirja
          let arr = [];
          Array.from(this.$store.state.storePaperType.paperType).forEach(
            (x) => {
              let item = {
                paperType: x.paperType,
                price: x.price,
                copies: 0,
              };
              arr.push(item);
            }
          );
          Vue.set(x, "sumPaperTypes", arr);
          Vue.set(x, "copies", 0);
        });

        // seštejemo koliko slik ima vsak format
        Array.from(this.uploadedFiles).forEach((file) => {
          // poiščemo pravo velikost in prištejemo št.kopij
          this.orderSummary.totalSumImageSizes.find(
            (item) => item.name == file.selectedFormat
          ).copies += parseInt(file.selectedCopies);

          this.orderSummary.totalSumImageSizes
            .find((item) => item.name == file.selectedFormat)
            .sumPaperTypes.find(
              (item2) => item2.paperType == file.selectedPaperType
            ).copies += parseInt(file.selectedCopies);

          // seštejemo količino slik v naročilu
          this.orderSummary.totalCopies += parseInt(file.selectedCopies);
        });
      }
      //console.log(this.orderSummary);
      this.showUpload = true;
      this.showGoUpload = false;
      this.uploadFiles();
    },
    uploadFiles() {
      // nekaj podatkov, za primer napake shranimo
      let errorObj = [];
      Array.from(this.uploadedFiles).forEach((fileToLoad) => {
        errorObj.push({
          name: fileToLoad.name !== undefined ? fileToLoad.name : "undefined",
          size: fileToLoad.size !== undefined ? fileToLoad.size : "undefined",
          type: fileToLoad.type !== undefined ? fileToLoad.type : "undefined",
          oHeight:
            fileToLoad.cHeight !== undefined ? fileToLoad.cHeight : "undefined",
          oWidth:
            fileToLoad.cWidth !== undefined ? fileToLoad.cWidth : "undefined",
        });
      });
      //console.log(errorObj);

      var zip = new JSZip();

      //zip.file("contents.txt", this.$store.state.storeAuth.user.uid); // Add an top-level, arbitrary text file with contents

      let counter = 1;
      Array.from(this.uploadedFiles).forEach((fileToLoad) => {
        // Add a file to the directory, in this case an image with data URI as contents
        //console.log(fileToLoad);

        // 1. IZBOLJŠAVA: Dinamično pridobivanje končnice (kot v App.vue)
        let affix = "jpg";
        if (this.simpleUpload) {
          // Uporabimo originalno končnico datoteke, če obstaja
          const parts = fileToLoad.name.split('.');
          if (parts.length > 1) {
            affix = parts.pop();
          }
        }

        // 2. IZBOLJŠAVA: Uporaba Template Literals za boljšo berljivost
        const paper = fileToLoad.selectedPaperTypeFile;
        const format = fileToLoad.selectedFormatFile;
        const border = fileToLoad.selectedWhiteBorder ? "-BR" : "";
        const copies = fileToLoad.selectedCopies;
        const date = (fileToLoad.selectedPrintDate && this.simpleUpload) ? "-DATE" : "";
        const fit = (fileToLoad.selectedFitIn == "FIT-IN" && this.simpleUpload) ? "-FIT" : "";
        const ac = fileToLoad.selectedAutoCorrection ? "" : "-NOAC";
        const count = String(counter).padStart(4, "0");
        const originalName = this.$store.state.storeClient.client.modules.modulePhotoOrder.keepOriginalFileNames
            ? "-" + fileToLoad.name.substring(0, fileToLoad.name.lastIndexOf("."))
            : "";

        const builtFileName = `${paper}-${format}${border}/${copies}${date}${fit}${ac}-${count}${originalName}.${affix}`;

        if (this.simpleUpload) {
          zip.file(builtFileName, fileToLoad, {
            date: new Date(moment(fileToLoad.lastModified)), // moramo dodati datum posebej, če ne JSZip spremeni v trenutnega
          });
        } else {
          // 3. IZBOLJŠAVA: Hitrejša ekstrakcija base64 niza (split namesto regex)
          const base64Data = fileToLoad.src.includes(',') 
            ? fileToLoad.src.split(',')[1] 
            : fileToLoad.src;
            
          zip.file(builtFileName, base64Data, { base64: true });
        }
        counter++;
      });

      // Generate the zip file asynchronously
      let vm = this;
      const fileNameType = this.$t("fileNamePackageImages");
      // preberemo ime uporabnika, če ga ni, potem predpono emaila, sicer pa random string
      let fileFullName =
        this.$store.state.storeAuth.userProfile.fullName !== undefined &&
        this.$store.state.storeAuth.userProfile.fullName.length > 0
          ? this.$store.state.storeAuth.userProfile.fullName.replace(/\W/g, "")
          : "";
      fileFullName =
        fileFullName.length > 0
          ? fileFullName
          : this.$store.state.storeAuth.userProfile.email !== undefined &&
            this.$store.state.storeAuth.userProfile.email.length > 0
          ? this.$store.state.storeAuth.userProfile.email.split("@")[0]
          : "";
      fileFullName = fileFullName.length > 0 ? fileFullName : makeId(5, 0);

      zip
        .generateAsync({ type: "blob" }, function updateCallback(metadata) {
          vm.$store.dispatch("generatingZipProgress", {
            progress: metadata.percent.toFixed(0),
            currentFile: metadata.currentFile,
          });
        })
        .then((content) => {
          const uploadFileName = `${fileFullName}-${fileNameType}-${moment().format(
            "YYYYMMDD"
          )}-${moment().format("HHmmss")}-${
            vm.$store.state.storeClient.client.basicSettings.name
          }.zip`;

          const uploadPath = G_STORAGE_DEFAULT_DIR + "/" + uploadFileName;

          const storageRef = storage.ref().child(uploadPath);
          let uploadTask = storageRef.put(content);
          let zipSize,
            rawZipSize = 0;

          uploadTask.on(
            "state_changed",
            function progress(snapshot) {
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              vm.$store.dispatch("uploadProgress", {
                progress: Math.trunc(progress),
                bytesTransferred: formatBytes(snapshot.bytesTransferred),
                totalBytes: formatBytes(snapshot.totalBytes),
              });
              zipSize = formatBytes(snapshot.totalBytes);
              rawZipSize = snapshot.totalBytes;
              //console.log(zipSize);
              /*switch (snapshot.state) {
              case "paused": // or 'paused'
                console.log("Upload is paused");
                break;
              case "running":
                console.log("Upload is running");
                break;
              } */
            },
            function error(error) {
              // SHOW AND ADD ERROR
              vm.errorMsgStr =
                vm.$t("commonNewOrderZipGenerationError") + " (1001)";
              vm.dialogErrorMsg = true;
              vm.$store.dispatch("addError", {
                code: 1001,
                client: vm.$store.state.storeClient.client.basicSettings.name,
                debugInfo: {
                  appVersion:
                    vm.$store.getters.appVersion !== undefined
                      ? vm.$store.getters.appVersion
                      : "",
                  appOS:
                    vm.$store.state.os !== undefined ? vm.$store.state.os : "",
                  appBrowser:
                    vm.$store.state.browser !== undefined
                      ? vm.$store.state.browser
                      : "",
                  appMemory:
                    vm.$store.state.memory !== undefined
                      ? String(vm.$store.state.memory)
                      : "",
                },
                details: "",
                email: vm.$store.state.storeAuth.user.email,
                errorObj: errorObj,
                file: "UserNewOrderBasic.vue",
                function: "uploadFiles.generateAsync.uploadTask.on.error",
                generated: error.message,
                simpleUpload: vm.simpleUpload,
                str: vm.errorMsgStr,
                timestamp: new Date(),
              });
            },
            function complete() {
              // generate download URL
              storage
                .ref()
                .child(uploadPath)
                .getDownloadURL()
                .then(function (url) {
                  //console.log(url);
                  vm.$store
                    .dispatch("addToCart", {
                      uid: String(vm.$store.state.storeAuth.user.uid),
                      module: G_MODULE_PHOTO_ORDER,
                      timestamp:
                        firebase.firestore.FieldValue.serverTimestamp(),
                      url: String(url),
                      zipSize: String(zipSize),
                      totalCopies: Number(vm.orderSummary.totalCopies),
                      rawZipSize: Number(rawZipSize),
                      client:
                        vm.$store.state.storeClient.client.basicSettings.name,
                      email: vm.$store.state.storeAuth.user.email,
                      cartId: uploadFileName,
                      itemDetails: vm.orderSummary.totalSumImageSizes.filter(
                        (item) => item.copies > 0
                      ),
                      status: 0,
                      done: false,
                      debugInfo: {
                        appVersion:
                          vm.$store.getters.appVersion !== undefined
                            ? vm.$store.getters.appVersion
                            : "",
                        appOS:
                          vm.$store.state.os !== undefined
                            ? vm.$store.state.os
                            : "",
                        appBrowser:
                          vm.$store.state.browser !== undefined
                            ? vm.$store.state.browser
                            : "",
                        appMemory:
                          vm.$store.state.memory !== undefined
                            ? String(vm.$store.state.memory)
                            : "",
                      },
                    })
                    .catch((error) => {
                      // SHOW AND ADD ERROR
                      vm.errorMsgStr =
                        vm.$t("commonNewOrderAddRecordError") + " (1003)";
                      vm.dialogErrorMsg = true;
                      vm.$store.dispatch("addError", {
                        code: 1003,
                        client:
                          vm.$store.state.storeClient.client.basicSettings.name,
                        debugInfo: {
                          appVersion:
                            vm.$store.getters.appVersion !== undefined
                              ? vm.$store.getters.appVersion
                              : "",
                          appOS:
                            vm.$store.state.os !== undefined
                              ? vm.$store.state.os
                              : "",
                          appBrowser:
                            vm.$store.state.browser !== undefined
                              ? vm.$store.state.browser
                              : "",
                          appMemory:
                            vm.$store.state.memory !== undefined
                              ? String(vm.$store.state.memory)
                              : "",
                        },
                        details: {
                          uid: String(vm.$store.state.storeAuth.user.uid),
                          module: G_MODULE_PHOTO_ORDER,
                          url: String(url),
                          zipSize: String(zipSize),
                          totalCopies: Number(vm.orderSummary.totalCopies),
                          rawZipSize: Number(rawZipSize),
                          cartId: uploadFileName,
                          itemDetails:
                            vm.orderSummary.totalSumImageSizes.filter(
                              (item) => item.copies > 0
                            ),
                          status: 0,
                          done: false,
                        },
                        email: vm.$store.state.storeAuth.user.email,
                        errorObj: errorObj,
                        file: "UserNewOrderBasic.vue",
                        function:
                          "uploadFiles.generateAsync.uploadTask.on.complete.getDownloadURL.addToCart.catch",
                        generated: error.message,
                        simpleUpload: vm.simpleUpload,
                        str: vm.errorMsgStr,
                        timestamp: new Date(),
                      });
                    });
                })
                .catch((error) => {
                  // SHOW AND ADD ERROR
                  vm.errorMsgStr =
                    vm.$t("commonNewOrderZipGenerationError") + " (1002)";
                  vm.dialogErrorMsg = true;
                  vm.$store.dispatch("addError", {
                    code: 1002,
                    client:
                      vm.$store.state.storeClient.client.basicSettings.name,
                    debugInfo: {
                      appVersion:
                        vm.$store.getters.appVersion !== undefined
                          ? vm.$store.getters.appVersion
                          : "",
                      appOS:
                        vm.$store.state.os !== undefined
                          ? vm.$store.state.os
                          : "",
                      appBrowser:
                        vm.$store.state.browser !== undefined
                          ? vm.$store.state.browser
                          : "",
                      appMemory:
                        vm.$store.state.memory !== undefined
                          ? String(vm.$store.state.memory)
                          : "",
                    },
                    details: "",
                    email: vm.$store.state.storeAuth.user.email,
                    errorObj: errorObj,
                    file: "UserNewOrderBasic.vue",
                    function:
                      "uploadFiles.generateAsync.uploadTask.on.complete.getDownloadURL.catch",
                    generated: error.message,
                    simpleUpload: vm.simpleUpload,
                    str: vm.errorMsgStr,
                    timestamp: new Date(),
                  });
                });
            }
          );
        })
        .catch((error) => {
          // SHOW AND ADD ERROR
          vm.errorMsgStr =
            vm.$t("commonNewOrderZipGenerationError") + " (1000)";
          vm.dialogErrorMsg = true;

          vm.$store.dispatch("addError", {
            code: 1000,
            client: vm.$store.state.storeClient.client.basicSettings.name,
            debugInfo: {
              appVersion:
                vm.$store.getters.appVersion !== undefined
                  ? vm.$store.getters.appVersion
                  : "",
              appOS: vm.$store.state.os !== undefined ? vm.$store.state.os : "",
              appBrowser:
                vm.$store.state.browser !== undefined
                  ? vm.$store.state.browser
                  : "",
              appMemory:
                vm.$store.state.memory !== undefined
                  ? String(vm.$store.state.memory)
                  : "",
            },
            details: "",
            email: vm.$store.state.storeAuth.user.email,
            errorObj: errorObj,
            file: "UserNewOrderBasic.vue",
            function: "uploadFiles.generateAsync.catch",
            generated: error.message,
            simpleUpload: vm.simpleUpload,
            str: vm.errorMsgStr,
            timestamp: new Date(),
          });
        });
    },
    beforeFilesChange() {
      this.loading = true;
      // nastavitev števcev za preview progress loader
      this.$store.dispatch("readingImages", 0);
      this.$store.dispatch("readingImagesLength", this.files.length);
      this.$store.dispatch("filesMBSize", 0);

      let vm = this;
      setTimeout(function () {
        vm.filesChange();
      }, 500);
    },
    filesChange() {
      // Ustvarimo kopijo, da ne spreminjamo vira med iteracijo
      const filesToProcess = Array.from(this.files);
      this.files = []; // Počistimo input

      let nextNum = this.uploadedFiles.length;
      let addedBatchSize = 0;

      const validFiles = [];

      // 1. Filtriranje datotek glede na limit
      for (const file of filesToProcess) {
        if (!this.isMaxLimit(file.size + addedBatchSize)) {
          this.currentProcessingFile = file.name;
          addedBatchSize += file.size;

          file.id = uuidv4();
          file.selectedFormat = this.newOrder.selectedFormat;
          file.selectedFormatFile = this.newOrder.selectedFormatFile;
          file.selectedPaperType = this.newOrder.selectedPaperType;
          file.selectedPaperTypeFile = this.newOrder.selectedPaperTypeFile;
          file.selectedCopies = this.newOrder.selectedCopies;
          file.selectedFitIn = this.newOrder.selectedFitIn;
          file.selectedWhiteBorder = this.newOrder.selectedWhiteBorder;
          file.selectedPrintDate = this.newOrder.selectedPrintDate;
          file.selectedAutoCorrection = this.newOrder.selectedAutoCorrection;
          file.num = nextNum;

          validFiles.push(file);

          this.thisOrderTotalImages += Number(this.newOrder.selectedCopies);
          nextNum++;
        } else {
          this.disableAdd = true;
          this.$store.commit({
            type: "showSnackbar",
            timeout: 6000,
            color: "warning",
            message: this.$t("userNewOrderBasicPackageFull"),
          });
          break; // Prekinemo, če je limit dosežen
        }
      }
      this.currentProcessingFile = "";

      // Posodobimo števec za loading dialog
      this.$store.dispatch("readingImagesLength", validFiles.length);

      if (validFiles.length === 0) {
        this.loading = false;
        return;
      }

      // 2. Obdelava datotek
      if (this.simpleUpload) {
        // Pri enostavnem nalaganju samo dodamo v seznam
        this.uploadedFiles = this.uploadedFiles.concat(validFiles);
        this.$store.dispatch("filesMBLimit", addedBatchSize);
        this.loading = false;
      } else {
        // Pri naprednem nalaganju moramo generirati predoglede (async)
        this.processFilesSequentially(validFiles);
      }
    },
    async processFilesSequentially(files) {
      let processedCount = 0;
      for (const file of files) {
        // Kratka pavza, da se UI osveži (progress bar, ime datoteke) preden začnemo z delom
        await new Promise((r) => setTimeout(r, 100));

        this.currentProcessingFile = file.name;
        this.showSkipButton = false;
        this.isConvertingHeic = false;

        // Timer za prikaz gumba preskoči po 3 sekundah
        const timer = setTimeout(() => {
          this.showSkipButton = true;
        }, 10000);

        try {
          // Posodobimo prikaz v loading dialogu
          this.$store.dispatch("filesMBSize", file.size);

          let fileToProcess = file;
          // Preverimo za HEIC format in pretvorimo v JPG
          if (
            file.type === "image/heic" ||
            file.name.toLowerCase().endsWith(".heic")
          ) {
            this.isConvertingHeic = true;
            await new Promise(r => setTimeout(r, 50)); // Damo UI-ju možnost, da prikaže sporočilo
            try {
              const blob = await heic2any({ blob: file, toType: "image/jpeg" });
              const convertedBlob = Array.isArray(blob) ? blob[0] : blob;
              fileToProcess = new File(
                [convertedBlob],
                file.name.replace(/\.heic$/i, ".jpg"),
                { type: "image/jpeg" }
              );
              // Kopiramo lastnosti, ki so bile dodane v filesChange
              fileToProcess.id = file.id;
              fileToProcess.selectedFormat = file.selectedFormat;
              fileToProcess.selectedFormatFile = file.selectedFormatFile;
              fileToProcess.selectedPaperType = file.selectedPaperType;
              fileToProcess.selectedPaperTypeFile = file.selectedPaperTypeFile;
              fileToProcess.selectedCopies = file.selectedCopies;
              fileToProcess.selectedFitIn = file.selectedFitIn;
              fileToProcess.selectedWhiteBorder = file.selectedWhiteBorder;
              fileToProcess.selectedPrintDate = file.selectedPrintDate;
              fileToProcess.selectedAutoCorrection = file.selectedAutoCorrection;
              fileToProcess.num = file.num;
            } catch (e) {
              // eslint-disable-next-line no-console
              console.warn("HEIC konverzija ni uspela, poskušam z originalno datoteko", e);
            } finally {
              this.isConvertingHeic = false;
            }
          }

          // Zavijemo preparePreview v nov Promise, da ga lahko ročno zavrnemo (preskočimo)
          const processed = await new Promise((resolve, reject) => {
            this.skipFileTrigger = reject;
            preparePreview([fileToProcess], "add").then(resolve).catch(reject);
          });

          this.uploadedFiles.push(processed[0]);

          if (!processed[0].cropped) this.thisOrderNotCroppedImages++;
          this.$store.dispatch("filesMBLimit", file.size);

        } catch (err) {
          if (err === "skipped") {
            this.failedFiles.push(file.name);
          } else {
            this.uploadError = err.response;
            this.failedFiles.push(file.name);
            // eslint-disable-next-line no-console
            console.error(err);
          }
        } finally {
          clearTimeout(timer);
          this.showSkipButton = false;
          this.skipFileTrigger = null;
          processedCount++;
          this.$store.dispatch("readingImages", processedCount);
        }
      }
      this.currentProcessingFile = "";
      this.loading = false;
    },
    skipCurrentFile() {
      // eslint-disable-next-line no-console
      console.log("Uporabnik je zahteval preskok datoteke.");
      if (this.skipFileTrigger) {
        this.skipFileTrigger("skipped");
        // Takoj počistimo, da preprečimo večkratne klike
        this.skipFileTrigger = null;
      }
    },
    // Stara metoda filesChange je bila nadomeščena z zgornjo logiko.
    // Spodnji blok else { this.loading = false } iz originalne kode je bil del pogoja if (whereIsTheLimit > 0)
    // V novi implementaciji je to pokrito z if (validFiles.length === 0)
    /*
      else {
        this.loading = false;
      }
    */
  },
  created() {
    this.setNewOrder();
  },
};
</script>
<style scoped>
.hover-item {
  cursor: pointer;
}
.img-container {
  /* Never limit the container height here */
  max-width: 100%;
}
</style>